<!--logo-->

<div class="logo-container">
    <a href="/{{trans.local}}/" class="logo" matTooltip="{{getHomeButtonName()}}">
        <img src="assets/images/whocan.svg" alt="{{ 'whocan'  | transMigrated | async}}">
    </a>
</div>